$(document).on('click', '.scroll-down', function () {
    const offset = $(this).offset();

    $('html, body').animate(
      {
        scrollTop: offset.top + 50,
      },
      1000
    );
  });

  $(document).on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();
    let attr = $(this).attr('href');
    let target = $(document.getElementById(attr.replace('#', '')));
    if (!target.length) {
      return;
    }

    $('html, body').animate(
      {
        scrollTop: target.offset().top - 50,
      },
      1000,
      'swing'
    );
  });
